import { AccountingLedgerBasis } from "../types/domains/accounting/ledger";

export interface SplitLineAssignmentFields {
    categoryId?: string;
    entityId?: number;
    splitDescription?: string;
    classIds?: string[];
    counterpartyId?: string | null;
    accountId?: string | null;
    accrualAccountId?: string | null;
    scheduleTemplateId?: string | null;
}

export function optionalSplitDescription(
    value: string | null | undefined,
): string | undefined {
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
}

export function copySplitLineAssignments(
    split: SplitLineAssignmentFields,
): SplitLineAssignmentFields {
    return {
        categoryId: split.categoryId,
        entityId: split.entityId,
        splitDescription: optionalSplitDescription(split.splitDescription),
        classIds: split.classIds,
        counterpartyId: split.counterpartyId,
        accountId: split.accountId,
        accrualAccountId: split.accrualAccountId,
        scheduleTemplateId: split.scheduleTemplateId,
    };
}

export function splitRuleShowsAutoConfirm(
    splits: ReadonlyArray<{
        accrualAccountId?: string | null;
        scheduleTemplateId?: string | null;
    }>,
): boolean {
    return splits.some(
        (split) =>
            Boolean(split.accrualAccountId) ||
            Boolean(split.scheduleTemplateId),
    );
}

export interface ScheduleAccountRowForHolding {
    entityId: number;
    basis: string;
    holdingAccountId: string;
}

export function scheduleAccrualHoldingAccountId(params: {
    accountRows: readonly ScheduleAccountRowForHolding[];
    entityId?: number;
}): string | undefined {
    const accrualRows = params.accountRows.filter(
        (row) => row.basis === AccountingLedgerBasis.accruals,
    );
    if (params.entityId !== undefined) {
        const holdingForEntity = accrualRows.find(
            (row) => row.entityId === params.entityId,
        )?.holdingAccountId;
        if (holdingForEntity) {
            return holdingForEntity;
        }
    }
    const uniqueHoldingIds = [
        ...new Set(accrualRows.map((row) => row.holdingAccountId)),
    ];
    return uniqueHoldingIds.length === 1 ? uniqueHoldingIds[0] : undefined;
}

export function resolveSplitLineAccrualAccountId(params: {
    hasSchedule: boolean;
    accrualAccountId?: string | null;
    scheduleHoldingAccountId?: string;
    clearedScheduleHoldingAccountId?: string;
}): string | undefined {
    if (params.hasSchedule) {
        return (
            params.scheduleHoldingAccountId ??
            params.accrualAccountId ??
            undefined
        );
    }
    if (
        params.accrualAccountId &&
        params.accrualAccountId !== params.clearedScheduleHoldingAccountId
    ) {
        return params.accrualAccountId;
    }
    return undefined;
}
